import LocationOnIcon from "@mui/icons-material/LocationOn";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import React from "react";

import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { Icon } from "leaflet";
import defaultIconPng from "leaflet/dist/images/marker-icon.png";
import { MapContainer, Marker, TileLayer } from "react-leaflet";

// external library
import "react-photo-view/dist/react-photo-view.css";

export function LocationButton(props) {
  const { value } = props;
  const [open, setOpen] = React.useState(false);
  const defaultIcon = new Icon({
    iconUrl: defaultIconPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    if (value?.latitude && value?.longitude) {
      containerRef?.current?.setView([value.latitude, value.longitude], 17);
    }
  }, [value]);
  return (
    <React.Fragment>
      <IconButton
        onClick={() => setOpen(true)}
        disabled={value?.latitude && value?.longitude ? false : true}
      >
        <LocationOnIcon fontSize="inherit" />
      </IconButton>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogContent style={{ paddingTop: 10 }}>
          <DialogContentText></DialogContentText>
        </DialogContent>
        <MapContainer
          center={[value?.latitude, value?.longitude]}
          zoom={13}
          scrollWheelZoom={false}
          ref={containerRef}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {value?.longitude && value?.latitude && (
            <React.Fragment>
              <Marker
                icon={defaultIcon}
                position={[value.latitude, value.longitude]}
              ></Marker>
            </React.Fragment>
          )}
        </MapContainer>
      </Dialog>
    </React.Fragment>
  );
}
